import { useState, useEffect } from "react";
import axios from "axios";
import { useSearchParams, useParams } from "react-router-dom";

export default function AccountActivated() {
  const { token: tokenParamPath } = useParams(); // token dans l'URL /account-activated/:token
  const [searchParams] = useSearchParams();      // email dans query string
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState(""); // reset password
  const [message, setMessage] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [token, setToken] = useState("");

useEffect(() => {
  const emailParam = searchParams.get("email");
  const tokenParam = searchParams.get("token") || tokenParamPath;

  if (tokenParam) {
    setToken(tokenParam);
    setShowReset(true);
  }
  if (emailParam) setEmail(emailParam);
}, [searchParams, tokenParamPath]);

  // --- Changement du mot de passe après activation ---
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!token) return setMessage("Token manquant !");
    if (!newPassword) return setMessage("Veuillez saisir un nouveau mot de passe.");

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/client/reset-password`, {
        token,
        newPassword,
      });

      // ✅ Login automatique via JWT
      localStorage.setItem("token", res.data.token);

      setMessage("Mot de passe réinitialisé et connecté !");
      setNewPassword("");
      setShowReset(false);

      // 🔹 Redirection vers le dashboard
      window.location.href = "/client/dashboard";
    } catch (err) {
      console.error(err);
      setMessage("Erreur lors du changement de mot de passe.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "450px",
          background: "white",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#2ecc71", marginBottom: "10px" }}>🎉 Compte activé !</h2>
        <p style={{ marginBottom: "25px", color: "#333" }}>
          Votre compte a été activé avec succès. Veuillez choisir un mot de passe.
        </p>

        {showReset && (
          <form onSubmit={handleResetPassword} style={{ textAlign: "left" }}>
            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontSize: "14px", fontWeight: "bold" }}>Email</label>
              <input
                type="email"
                value={email}
                readOnly
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  marginTop: "5px",
                  background: "#f0f0f0",
                }}
              />
            </div>
            <div style={{ marginBottom: "15px" }}>
              <label style={{ fontSize: "14px", fontWeight: "bold" }}>Nouveau mot de passe</label>
              <input
                type="password"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  marginTop: "5px",
                }}
              />
            </div>
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "12px",
                background: "#2ecc71",
                color: "white",
                fontWeight: "bold",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Changer le mot de passe
            </button>
          </form>
        )}

        {message && <p style={{ marginTop: "15px", color: "#e74c3c" }}>{message}</p>}
      </div>
    </div>
  );
}
